// Elements
import { Filter, Label, LabelRow, Select } from "./Filters.elements";

// Resolve the default country for a locale (e.g. "de-de" -> "DE"), falling back
// to "GB" when the locale's country isn't in the available list.
export function resolveInitialCountryId(countries, locale) {
  const codes = countries
    .map((zone) => zone.countries.map((c) => c.key))
    .flat();
  const split = locale.split("-");
  // Map en-sg to tw country
  const validLocale =
    locale === "en-sg"
      ? "TW"
      : split.length > 1
      ? split[1].toUpperCase()
      : "GB";
  return codes.includes(validLocale) ? validLocale : "GB";
}

export function buildSelect({ name, label, all, items, countryId, onChangeHandler, hideSelect, market, labelExtra }) {
  function translate(item) {
    // Fall back to "en" value...
    const f = item.translations[market] || item.translations["en"];
    return f.title;
  }
  return (
    <Filter style={{'display': hideSelect ? 'none' : ''}}>
      {labelExtra ? (
        <LabelRow>
          <Label>{label}</Label>
          {labelExtra}
        </LabelRow>
      ) : (
        <Label>{label}</Label>
      )}
      <Select name={name} id={name} onChange={onChangeHandler}>
        <option value="">{all}</option>
        {items.map((item) => (
          <option key={`${countryId}-${item.id}`} value={item.id}>
            {translate(item)}
          </option>
        ))}
      </Select>
    </Filter>
  );
}
